export default __webpack_public_path__ + "df7b097647d58061063e118322bb860a.png";